import { useGraphql } from 'utils/hooks/useGraphql';

import { DEFAULT_LISTS, USE_LISTS_HOOK_QUERY } from './constants';
import { UseListsHookInputs, UseListsHookOutput, UseListsQueryData } from './types';
import { useListsVariables } from './useListsVariables';

export const useLists = ({
  search,
  page = 0,
  excludeDynamicLists = false,
}: UseListsHookInputs): UseListsHookOutput => {
  const variables = useListsVariables(search, page, excludeDynamicLists);
  const {
    data: { lists: data } = {},
    error: didError,
    isLoading,
  } = useGraphql<UseListsQueryData>(USE_LISTS_HOOK_QUERY, { variables });
  return {
    lists: data?.results ?? DEFAULT_LISTS,
    didError,
    isLoading,
    listsCount: data?.info?.count || 0,
  };
};
